import { useEffect, useState } from "react";
import { api, money, fmtDate } from "@/lib/api";
import { PageHead } from "@/pages/admin/AdminLayout";
import { StatusPill } from "@/pages/admin/Players";

const Table = ({ head, children, testid }) => (
  <div className="rounded-2xl border border-white/10 overflow-x-auto mb-10" data-testid={testid}>
    <table className="w-full text-sm">
      <thead className="text-left text-[11px] font-mono-epl uppercase tracking-wider text-slate-500 border-b border-white/10"><tr>{head.map((h) => <th key={h} className="px-4 py-3 font-medium">{h}</th>)}</tr></thead>
      <tbody>{children}</tbody>
    </table>
  </div>
);
export { Table };

export default function Payments() {
  const [orders, setOrders] = useState([]);
  const [refunds, setRefunds] = useState([]);
  useEffect(() => {
    api.get("/admin/orders").then((r) => setOrders(r.data));
    api.get("/admin/refunds").then((r) => setRefunds(r.data));
  }, []);
  return (
    <div data-testid="admin-payments">
      <PageHead title="Payments & refunds" />
      <Table head={["Created", "Parent", "Players", "Amount", "Status", "Source"]} testid="orders-table">
        {orders.map((o) => (
          <tr key={o.order_id} className="border-b border-white/5">
            <td className="px-4 py-3 text-slate-400">{fmtDate(o.created_at)}</td>
            <td className="px-4 py-3">{o.parent_email}</td>
            <td className="px-4 py-3">{o.registration_ids.length}</td>
            <td className="px-4 py-3 font-mono-epl">{money(o.amount_cents)}</td>
            <td className="px-4 py-3"><StatusPill s={o.payment_status === "paid" ? "confirmed" : o.payment_status} /></td>
            <td className="px-4 py-3 text-slate-400">{o.utm?.utm_source || "direct"}</td>
          </tr>
        ))}
      </Table>
      <h2 className="font-display font-bold text-xl mb-4">Refund history</h2>
      <Table head={["Date", "Amount", "Percent", "By", "Stripe ref"]} testid="refunds-table">
        {refunds.map((x) => (
          <tr key={x.id} className="border-b border-white/5">
            <td className="px-4 py-3 text-slate-400">{fmtDate(x.at)}</td>
            <td className="px-4 py-3 font-mono-epl">{money(x.amount_cents)}</td>
            <td className="px-4 py-3">{x.percent}%</td>
            <td className="px-4 py-3">{x.by}</td>
            <td className="px-4 py-3 font-mono-epl text-xs text-slate-500">{x.id}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
